import * as chalk from 'chalk';

const log = console.log;

export const logError = (message: string) => log(chalk.red(message));
export const logSuccess = (message: string) => log(chalk.green(message));
export const logWarning = (message: string) => log(chalk.yellow(message));
export const logInfo = (message: string) => log(chalk.blue(message));
